import { useEffect } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'

import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline'
import { Box, Button, Typography } from '@mui/material'

import LoadingComponent from 'components/LoadingComponent'

import { getUserImpersonate } from 'services/api'

import { useQuery } from '@tanstack/react-query'

import { useUser } from 'UserContext'

const ImpersonateLoginPage = () => {
  const [searchParams] = useSearchParams()
  const token = searchParams.get('token') || ''
  const navigate = useNavigate()
  const { enableAuth } = useUser()

  const { data, isLoading, isError } = useQuery({
    queryKey: ['user-impersonate', token],
    queryFn: () => getUserImpersonate({ token }),
    enabled: !!token,
    retry: false,
  })

  useEffect(() => {
    if (data?.token) {
      enableAuth()
      navigate('/', { replace: true })
    }
  }, [data?.token, enableAuth, navigate])

  if (isLoading) return <LoadingComponent />

  if (isError || !token) {
    return (
      <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
        height="100vh"
        textAlign="center"
        gap={2}
        px={2}
      >
        <ErrorOutlineIcon color="error" sx={{ fontSize: 64 }} />
        <Typography variant="h5" fontWeight={600}>
          Impersonation link not valid
        </Typography>
        <Typography variant="body1" color="text.secondary" maxWidth={400}>
          The impersonation link may have expired or already been used.
          <br />
          Please generate a new link from the admin panel.
        </Typography>

        <Box display="flex" gap={2} mt={2}>
          <Button variant="outlined" onClick={() => navigate(-1)}>
            Go Back
          </Button>
          <Button variant="contained" onClick={() => navigate('/')}>
            Return Home
          </Button>
        </Box>
      </Box>
    )
  }

  return (
    <Box
      display="flex"
      alignItems="center"
      justifyContent="center"
      height="100vh"
      flexDirection="column"
      textAlign="center"
    >
      <Typography variant="h6">Processing impersonation…</Typography>
      <LoadingComponent />
    </Box>
  )
}

export default ImpersonateLoginPage
